'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _misc = require('HubStyleTokens/misc');

var _sizes = require('HubStyleTokens/sizes');

var _theme = require('HubStyleTokens/theme');

var _times = require('HubStyleTokens/times');

var _UIScrollContainer = require('../scroll/UIScrollContainer');

var _UIScrollContainer2 = _interopRequireDefault(_UIScrollContainer);

var _UISection = require('../section/UISection');

var _UISection2 = _interopRequireDefault(_UISection);

var _component = require('../utils/propTypes/component');

var _component2 = _interopRequireDefault(_component);

var _Styles = require('../utils/Styles');

var _Color = require('../core/Color');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TH_BACKGROUND_COLOR = (0, _Color.hexToTransparentRGBA)(_theme.TABLE_HEADER_BACKGROUND_COLOR);

var Section = (0, _styledComponents2.default)(_UISection2.default).attrs({
  className: function className(_ref) {
    var _className = _ref.className;
    return (0, _classNames2.default)(_className, 'table-responsive', 'private-scroll__wrapper--tables');
  }
}).withConfig({
  displayName: 'UITable__Section'
})(['', ';'], function (props) {
  return props.flush && '\n    && {\n      margin-bottom: 0;\n    }\n  ';
});

var TableScrollContainer = (0, _styledComponents2.default)(_UIScrollContainer2.default).withConfig({
  displayName: 'UITable__TableScrollContainer'
})(['height:', ';'], function (_ref2) {
  var scrollDirection = _ref2.scrollDirection;
  return scrollDirection === 'both' && '100%';
});

var Table = _styledComponents2.default.table.attrs({
  className: function className(_ref3) {
    var _className2 = _ref3.className,
        bordered = _ref3.bordered,
        condensed = _ref3.condensed,
        hover = _ref3.hover,
        responsive = _ref3.responsive;
    return (0, _classNames2.default)('table private-table', _className2, {
      'table-bordered private-table--bordered': bordered,
      'table-condensed private-table--condensed': condensed,
      'table-hover private-table--hover': hover,
      'private-table--responsive': responsive
    });
  }
}).withConfig({
  displayName: 'UITable__Table'
})(['font-size:', ';background-color:', ';border-collapse:collapse;width:100%;', ';th,td{border-color:', ';border-style:solid;border-width:1px 0 0;line-height:normal;vertical-align:middle;}thead{th{', ';font-size:', ';background-color:', ';color:', ';height:', ';padding-bottom:', ';padding-left:', ';padding-right:', ';padding-top:', ';text-align:left;text-transform:uppercase;vertical-align:', ';}}tfoot{td,th{', ';height:', ';padding:', ' ', ';text-align:left;}}tbody{td{hyphens:auto;height:', ';overflow-wrap:break-word;padding:', ' ', ';vertical-align:', ';.private-tag--inline{vertical-align:', ';}}}', ';', ';', ';', ';.private-scroll__wrapper--horizontal &{background-color:transparent;@media only screen and (max-width:', '){table-layout:auto;}}.private-card &{border:0;border-radius:inherit;thead{th,.private-table__header--sortable,.private-table-sort-toggle{background-color:transparent;border-top:0;}}}.private-panel__body &{', ';}'], _sizes.TABLE_DEFAULT_FONT_SIZE, _theme.TABLE_BACKGROUND_COLOR, function (props) {
  return (props.flush || props.responsive) && '&& { margin-bottom: 0; }';
}, _theme.TABLE_BORDER_COLOR, _Styles.FONT_FAMILIES.medium, _sizes.TABLE_HEADER_FONT_SIZE, TH_BACKGROUND_COLOR, _theme.BASE_FONT_COLOR, _sizes.TABLE_HEADER_HEIGHT, _sizes.TABLE_HEADER_PADDING_BOTTOM, _sizes.TABLE_DEFAULT_PADDING_X, _sizes.TABLE_DEFAULT_PADDING_X, _sizes.TABLE_HEADER_PADDING_TOP, _misc.TABLE_HEADER_VERTICAL_ALIGNMENT, _Styles.FONT_FAMILIES.demibold, _sizes.TABLE_CELL_HEIGHT, _sizes.TABLE_DEFAULT_PADDING_Y, _sizes.TABLE_DEFAULT_PADDING_X, _sizes.TABLE_CELL_HEIGHT, _sizes.TABLE_DEFAULT_PADDING_Y, _sizes.TABLE_DEFAULT_PADDING_X, _misc.TABLE_CELL_VERTICAL_ALIGNMENT, _misc.TABLE_CELL_VERTICAL_ALIGNMENT, function (props) {
  return props.bordered && '\n      border-color: ' + _theme.TABLE_BORDER_COLOR + ';\n      border-style: solid;\n      border-width: 0 1px 1px;\n  ';
}, function (props) {
  return props.condensed && '\n      thead th {\n        height: ' + _sizes.TABLE_HEADER_HEIGHT + ';\n        padding-bottom: ' + _sizes.TABLE_COMPACT_PADDING_Y + ';\n        padding-top: ' + _sizes.TABLE_COMPACT_PADDING_Y + '\n      }\n\n      tbody {\n        td, th {\n          height: ' + _sizes.TABLE_COMPACT_CELL_HEIGHT + ';\n          padding-bottom: ' + _sizes.TABLE_COMPACT_PADDING_Y + ';\n          padding-top: ' + _sizes.TABLE_COMPACT_PADDING_Y + ';\n        }\n      }\n  ';
}, function (props) {
  return props.hover && '\n      tbody {\n        tr {\n          transition: background-color ' + _times.MICRO_TRANSITION_TIMING + ' ease-out;\n        }\n        tr:hover,\n        tr .private-table--hovered {\n          background-color: ' + _theme.TABLE_ROW_HOVER_BACKGROUND_COLOR + ';\n        }\n      }\n  ';
}, function (props) {
  return props.truncated && '\n      table-layout: fixed;\n\n      td,\n      th {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n  ';
}, _sizes.GRID_BREAKPOINT_MEDIUM, function (props) {
  return props.bordered && 'border-width: 0 0 1px;';
});

var UITable = function (_React$Component) {
  _inherits(UITable, _React$Component);

  function UITable() {
    _classCallCheck(this, UITable);

    return _possibleConstructorReturn(this, (UITable.__proto__ || Object.getPrototypeOf(UITable)).apply(this, arguments));
  }

  _createClass(UITable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          bordered = _props.bordered,
          children = _props.children,
          className = _props.className,
          condensed = _props.condensed,
          flush = _props.flush,
          height = _props.height,
          hover = _props.hover,
          responsive = _props.responsive,
          responsiveWrapperClassName = _props.responsiveWrapperClassName,
          ScrollContainer = _props.ScrollContainer,
          truncated = _props.truncated,
          rest = _objectWithoutProperties(_props, ['bordered', 'children', 'className', 'condensed', 'flush', 'height', 'hover', 'responsive', 'responsiveWrapperClassName', 'ScrollContainer', 'truncated']);

      var renderedTable = _react2.default.createElement(
        Table,
        _extends({}, rest, {
          className: className,
          bordered: bordered,
          condensed: condensed,
          flush: flush,
          hover: hover,
          responsive: responsive,
          truncated: truncated
        }),
        children
      );

      return responsive ? _react2.default.createElement(
        Section,
        {
          className: responsiveWrapperClassName,
          flush: flush,
          height: height
        },
        _react2.default.createElement(
          ScrollContainer,
          {
            scrollDirection: height != null ? 'both' : 'horizontal'
          },
          renderedTable
        )
      ) : renderedTable;
    }
  }]);

  return UITable;
}(_react2.default.Component);

exports.default = UITable;


UITable.propTypes = {
  bordered: _react.PropTypes.bool.isRequired,
  children: _react.PropTypes.node.isRequired,
  condensed: _react.PropTypes.bool.isRequired,
  flush: _react.PropTypes.bool.isRequired,
  height: _UISection2.default.propTypes.height,
  hover: _react.PropTypes.bool.isRequired,
  responsive: _react.PropTypes.bool.isRequired,
  responsiveWrapperClassName: _react.PropTypes.string,
  ScrollContainer: _component2.default.isRequired,
  truncated: _react.PropTypes.bool.isRequired
};

UITable.defaultProps = {
  bordered: true,
  condensed: false,
  flush: false,
  hover: true,
  responsive: true,
  ScrollContainer: TableScrollContainer,
  truncated: false
};

UITable.displayName = 'UITable';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/table/UITable.js
// module id = 671
// module chunks = 3 4